__turbopack_context__.v({
  "fade-in": "OverflowCarouselNav-module-scss-module__x_K3FW__fade-in",
  "navCount": "OverflowCarouselNav-module-scss-module__x_K3FW__navCount",
  "navItem": "OverflowCarouselNav-module-scss-module__x_K3FW__navItem",
  "root": "OverflowCarouselNav-module-scss-module__x_K3FW__root",
});
